import { render, staticRenderFns } from "./OrderTotalsRow.vue?vue&type=template&id=49f8f2ed&scoped=true&"
import script from "./OrderTotalsRow.vue?vue&type=script&lang=js&"
export * from "./OrderTotalsRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderTotalsRow.vue?vue&type=style&index=0&id=49f8f2ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8f2ed",
  null
  
)

export default component.exports